import moment from "moment";

import { Select, DatePicker, Button, Spin, Tabs } from "antd";
import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
import { getDataPost_2 } from "../../../data/allfunction_2";
import { formatFloatNumber } from "../../../App";
import { pad } from "../../../data/allfunction";
import {
  ButtonDowloadPDFNonMotor,
  changeDataForExcellNonMotor,
  ExcelExportNonMotor,
} from "./ReportAllByAgentAndConId";
const ip = process.env.REACT_APP_IP;
// const { TabPane } = Tabs;
const dateFormat = "DD-MM-YYYY";
const { Option } = Select;
export default function ReportAllByAgent({ userRedux }) {
  const [datat_get, setdatat_get] = useState([]);
  const [data_for_excell, setdata_for_excell] = useState([]);
  const [cur, set_cur] = useState([]);
  const [datat_get_curr, setdatat_get_curr] = useState([]);
  const [user_id_get, setuser_id_get] = useState(0);
  const [loading, setloading] = useState(false);
  const [con_create_start, set_con_create_start] = useState(Date.now());
  const [con_create_end, set_con_create_end] = useState(Date.now());

  const [total_con_pre_last, settotal_con_pre_last] = useState(0);
  const [total_con_total_pre_last, settotal_con_total_pre_last] = useState(0);
  const [total_con_com_money, settotal_con_com_money] = useState(0);
  const [total_con_tax_money, settotal_con_tax_money] = useState(0);
  const [total_zji_get, settotal_zji_get] = useState(0);

  //   console.log(userRedux);
  function onChange_timestart(value, dateString) {
    console.log(value);
    set_con_create_start(moment(value).format("YYYY-MM-DD"));
  }
  function onChange_timeend(value, dateString) {
    console.log(value);
    set_con_create_end(moment(value).format("YYYY-MM-DD"));
  }

  async function getPolicyNonMotor() {
    let rows = {
      agent_id: userRedux.agent_id,
      con_create_start,
      con_create_end,
      user_id_get,
    };
    console.log(rows);
    let l = ip + "non_motor/_3";
    let hpa_data = await getDataPost_2(
      l,
      rows,
      userRedux.token,
      userRedux.retoken
    );
    //  console.log(hpa_data)
    let currencies;
    if (hpa_data.data.length > 0) {
      setdatat_get(hpa_data.data);
      setdatat_get_curr([]);

      currencies = hpa_data.data.map((e) => {
        return e.op_day_cur;
      });
      set_cur([...new Set(currencies)]);
      setdata_for_excell(changeDataForExcellNonMotor(hpa_data.data));
    } else {
      setdatat_get([]);
      setdatat_get_curr([]);
      setdata_for_excell([]);
    }
  }

  useEffect(() => {
    let _total_con_pre_last = 0,
      _total_con_total_pre_last = 0,
      _total_con_com_money = 0,
      _settotal_con_tax_money = 0,
      _total_zji_get = 0;

    datat_get_curr.map((e) => {
      _total_con_pre_last += parseFloat(e.con_pre_last) || 0;
      _total_con_total_pre_last += parseFloat(e.con_total_pre_last) || 0;
      _total_con_com_money += parseFloat(e.con_com_money) || 0;
      _settotal_con_tax_money += parseFloat(e.con_tax_money) || 0;
      _total_zji_get += parseFloat(e.zji_get) || 0;
    });

    settotal_con_pre_last(_total_con_pre_last);
    settotal_con_total_pre_last(_total_con_total_pre_last);
    settotal_con_com_money(_total_con_com_money);
    settotal_con_tax_money(_settotal_con_tax_money);
    settotal_zji_get(_total_zji_get);
  }, [datat_get_curr]);

  return (
    <div>
      <div className="d-flex flex-row">
        <div className="flex-fill">
          <strong>ລະຫັດຕົວແທນ: {userRedux.user}</strong>
          <br />
          <strong>ຊື່ຕົວແທນ: {userRedux.name}</strong>
          <br />
        </div>
        <div className="flex-fill ml-2">
          <strong>ເລືອກປະເພດການຊຳລະຂອງສັນຍາ</strong>
          <Select
            placeholder="ເລືອກປະເພດການຊຳລະຂອງສັນຍາ"
            optionFilterProp="children"
            style={{ width: "100%" }}
            value={user_id_get}
            onChange={(e) => {
              console.log(e);
              setuser_id_get(e);
              // user_id_get 1 paid 0 not paid null all
            }}
          >
            <Option key={1} value={null}>
              {" "}
              ສັນຍາທັງໝົ້ດ{" "}
            </Option>
            <Option key={2} value={0}>
              {" "}
              ສັນຍາຄ້າງຈ່າຍ{" "}
            </Option>
            <Option key={3} value={1}>
              {" "}
              ສັນຍາຈ່າຍແລ້ວ{" "}
            </Option>
          </Select>
        </div>
      </div>
      <hr />
      <div className="d-flex flex-row">
        <div className="flex-fill">
          <div className="d-flex flex-row">
            <div className="mr-1 ml-1">ເລີ່ມແຕ່ວັນທີ::</div>
            <div className="flex-fill mr-1 ml-1">
              <DatePicker
                placeholder="ເລີ່ມແຕ່ວັນທີ"
                style={{ width: "100%" }}
                //  showTime
                onChange={onChange_timestart}
                format={dateFormat}
              />
            </div>
          </div>
        </div>
        <div className="flex-fill">
          <div className="d-flex flex-row px-1">
            <div className="mr-1 ml-1">ສິ້ນສຸດວັນທີ::</div>
            <div className="flex-fill mr-1 ml-1">
              <DatePicker
                style={{ width: "100%" }}
                placeholder="ສິ້ນສຸດວັນທີ"
                //  showTime
                onChange={onChange_timeend}
                format={dateFormat}
              />
            </div>
          </div>
        </div>
        <div className="flex-fill">
          <Button
            // disabled={confirm}
            onClick={() => {
              getPolicyNonMotor();
            }}
            style={{ width: "100%" }}
            type="primary"
          >
            {" "}
            ຄົ້ນຫາ{" "}
          </Button>
        </div>
      </div>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "20%",
            left: "45%",
          }}
        >
          <Spin tip="ກຳລັງໂຫລດຂໍ້ມູນ..." />
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 10,
        }}
      >
        <div>
          <h5> ຈຳນວນສັນຍາທັງໝົ້ດ {datat_get.length} ສັນຍາ (ທຸກສະກຸນເງິນ)</h5>
        </div>
      </div>
      {/* {cur} */}
      ມີສະກຸນເງິນ (ກະລຸນາຄລິກທີ່ສະກຸນເງິນທີ່ຕ້ອງການກວດສອບ):{" "}
      {cur.map((e, i) => (
        <>
          <Button
            key={i}
            onClick={() => {
              console.log(e);
              let filteredData = datat_get.filter(
                (cur) => cur.op_day_cur === e
              );
              setdatat_get_curr(filteredData);
            }}
          >
            {e}
          </Button>{" "}
        </>
      ))}
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>ເລກທີສັນຍາ</th>
            <th>ຊື່ສັນຍາ</th>
            <th>ວັນທີສ້າງສັນຍາ</th>
            <th>ປະເພດການຄຸ້ມກັນ</th>
            <th>ຊື່ແພັກແກັດ</th>
            <th>ຊື່ທາງເລືອກ</th>
            <th>ຈຳນວນວັນຄຸ້ມກັນ</th>
            <th>ວັນທີເລີ່ມຄຸ້ມກັນ</th>
            <th>ວັນທີສິ້ນສຸດຄຸ້ມກັນ</th>
            <th>ຄ່າທຳນຽມຕົ້ນ</th>
            <th>ຄ່າທຳນຽມທັງໝົ້ດ</th>
            <th>ຄ່າຄອມຕົວແທນ</th>
            <th>ຄ່າຄອມຕົວແທນຈ່າຍອາກອນ</th>
            <th>ເງິນ ZJI ໄດ້ຮັບ</th>
            <th>ສະກຸນເງິນ</th>
            <th>ການຊຳລະ</th>
          </tr>
        </thead>
        <tbody>
          {datat_get_curr.map((oneData, key) => {
            return (
              <tr key={key}>
                <td>{key + 1}</td>
                <td>
                  {/* {JSON.stringify(userRedux.token)}
                {JSON.stringify(userRedux.retoken)} */}
                  <ButtonDowloadPDFNonMotor
                    con_id={oneData.con_id}
                    token={userRedux.token}
                    retoken={userRedux.retoken}
                  />
                </td>
                <td>{oneData.con_name}</td>
                <td>{moment(oneData.con_create).format("DD-MM-YYYY")}</td>
                <td>{oneData.type_cov_name}</td>
                <td>{oneData.con_pac_name}</td>
                <td>{oneData.con_op_name}</td>
                <td>{oneData.con_day_name}</td>
                <td>{moment(oneData.con_start).format("DD-MM-YYYY")}</td>
                <td>{moment(oneData.con_end).format("DD-MM-YYYY")}</td>

                <td>{formatFloatNumber(oneData.con_pre_last)} </td>
                <td>{formatFloatNumber(oneData.con_total_pre_last)}</td>
                <td>
                  {oneData.con_com_last * 100}% ={" "}
                  {formatFloatNumber(oneData.con_com_money)}
                </td>

                <td>
                  {oneData.con_tax * 100}% ={" "}
                  {formatFloatNumber(oneData.con_tax_money)}
                </td>
                <td>{formatFloatNumber(oneData?.zji_get)}</td>
                <td>{oneData.op_day_cur}</td>
                <td>
                  {oneData.user_id_get == null ? (
                    <strong style={{ color: "red" }}> ຄ້າງຈ່າຍ </strong>
                  ) : (
                    "ຈ່າຍແລ້ວ"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
        {datat_get_curr.length > 0 && (
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>

              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_con_pre_last)}
              </th>
              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_con_total_pre_last)}
              </th>
              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_con_com_money)}
              </th>
              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_con_tax_money)}
              </th>
              <th style={{ textAlign: "right" }}>
                {formatFloatNumber(total_zji_get)}
              </th>

              <th></th>
              <th></th>
            </tr>
          </tfoot>
        )}
      </table>
      {data_for_excell.length > 0 && (
        <ExcelExportNonMotor data={data_for_excell} />
      )}
    </div>
  );
}
